import { render, staticRenderFns } from "./performanceDetails.vue?vue&type=template&id=23209917&scoped=true"
import script from "./performanceDetails.vue?vue&type=script&lang=js"
export * from "./performanceDetails.vue?vue&type=script&lang=js"
import style0 from "./performanceDetails.vue?vue&type=style&index=0&id=23209917&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23209917",
  null
  
)

export default component.exports